export enum TaskType {
    SYNC,
}
